<template>
    <div id="footer">
        <div class="footer" style="text-align:center;">
            <p>
                <span>单证通</span>
                <span>|</span>
                <span><a href="https://beian.miit.gov.cn" target="_blank" rel="nofollow">京ICP备18021895号-1</a></span>
                <span>|</span>
                <span>
                    <a target="_blank"
                        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040963"
                        rel="nofollow">
                        <img src="https://cdn.001.bailian-ai.com/qudaobao/images/beian.png" alt="京公网安备" />
                        京公网安备 11010502040963号
                    </a>
                </span>
                <span>|</span>
                <span><a href="http://www.bailian-ai.com" target="_blank" rel="nofollow">版权所有：北京数智科技科技有限公司</a></span>
                <span>|</span>
                <span><a href="javascript:;" rel="nofollow">联系电话：010-84742379</a></span>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'footerComponent',
    data() {
        return {};
    },
    computed: {},
    components: {},
    methods: {}
};
</script>
<style>
    #footer {
        color: #bbb;
        background: #373c4d;
        height: 45px;
        line-height: 45px;
        width: 100%;
        overflow: hidden;

        .footer {
            width: 100%;
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
            color: #bbbbbb;
            letter-spacing: 0.2px;
            display: flex;
            align-items: center;
            justify-content: center;

            img,
            span {
                margin-right: 10px;
                vertical-align: middle;
            }

            a {
                color: #bbb;

                &:hover {
                    color: #fff;
                    text-decoration: none !important;
                }
            }
        }
    }
</style>